import React, { useEffect, useRef } from 'react';
import { Grid } from '@mui/material';
import { useLocation } from 'react-router-dom';
import StarRatingHeader from './StarRating/StarRatingHeader';
import StarRatingControl from './StarRating/StarRatingControl';
import StarRatingSubHeader from './StarRating/StarRatingSubHeader';
import useStarRatingLogic from './StarRating/useStarRatingLogic';

const StarRating = ({ id }) => {
  const containerRef = useRef(null);
  const location = useLocation();
  const currentPage = location.pathname;

  const {
    starValue, subStarValue, rate, setRate,
    handleStarChange, handleSubStarChange,
    isReadOnly, isSubHeaderVisible, isHeadingFocused,
    handleClickOutside, handleHeadingFocus, handleHeadingBlur,
    SubHeadingInputFontSize, HeadingColor
  } = useStarRatingLogic(id, containerRef, currentPage);

  return (
    <Grid
      ref={containerRef}
      mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
      p={'12px 10px'}
      mx={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '4px' : '0px'}
      bgcolor={'white'}
      border={`2px solid ${isHeadingFocused && !isReadOnly ? '#0293e2' : 'transparent'}`}
      onClick={handleClickOutside}
    >
      <StarRatingHeader
        value={starValue}
        onChange={handleStarChange}
        onFocus={handleHeadingFocus}
        onBlur={handleHeadingBlur}
        isReadOnly={isReadOnly}
        HeadingColor={HeadingColor}
      />
      <StarRatingControl rate={rate} setRate={setRate} isReadOnly={isReadOnly} />
      {isSubHeaderVisible && (
        <StarRatingSubHeader
          value={subStarValue}
          onChange={handleSubStarChange}
          isReadOnly={isReadOnly}
          fontSize={SubHeadingInputFontSize}
        />
      )}
    </Grid>
  );
};

export default StarRating;
